import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchAllCommittees , fetchMyCommittees, joinCommittee, committeeDirectLinkSwitchTab, switchMainTabDispatch } from '../actions';
import MainTab from './main-tab';
import OverviewPage from './overview-page';
import CommitteesPage from './committees-page';
import MeetingsPage from './meetings-page';
import DocumentsPage from './documents-page';
class Committees extends Component {

	constructor(props){
		super(props);
		this.directLinkCommitteeCode = getDirectCcode();
	}


	componentWillMount() {
		this.props.fetchAllCommittees();
		this.props.fetchMyCommittees();
	}

	getLoginBanner(){

		return (					<div className="information-banner warning container"><p><span className="glyphicon glyphicon-info-sign" aria-hidden="true" />
			Login to access My ISDA Committee Dashboard</p><a href={ get_home_page_url() + '/my-account?redirect_to=/committees' } className="btn btn-default">Login</a>
		</div>);
	}


	getNonMemberBanner(){
		return (					<div className="information-banner container"><p><span className="glyphicon glyphicon-info-sign" aria-hidden="true" />
			To get access to My ISDA Committee Dashboard become a <a href="/membership"> member</a></p>
		</div>);
	}

	getCommitteeDashboardInstructions() {
		//TODO make this a rich text field so we can have this text easily editable in the future if needed.
		return (
			<div className="committee-dashboard-instructions-container container"><p>For
				instructions on how to use this dashboard, click <a
					href={ getCommitteeDashboardInstructionsLink() }
					target="_blank">here</a>.</p>
			</div>
		);
	}

	render() {



		if(getImisInfo() == null || (!is_member() && this.props.myCommittees.length === 0 && this.props.requestedCommittees.length === 0 )){
			let banner = (getImisInfo() !== null && !is_member()) ? this.getNonMemberBanner() : this.getLoginBanner();
			return (
				<div>
					{banner}
					<CommitteesPage/>
				</div>);
		}

		if(this.directLinkCommitteeCode && !this.props.hasSwitchedForDirectLink){
			this.props.switchMainTabDispatch('committees');
		}

		let mainView = '';
		switch(this.props.mainTab){
			default:
			case 'My Dashboard':
				mainView = (<OverviewPage/>);
			break;
			case 'committees':
				mainView = (<CommitteesPage/>);
			break;
			case 'meetings':
				mainView = (<MeetingsPage/>);
			break;
			case 'documents':
				mainView = (<DocumentsPage/>);
			break;

		}


		return (<section id="committees-component">
				<MainTab tabs={[
					{'name':'My Dashboard','icon':'glyphicon glyphicon-th-large'} ,
					{'name':'committees','icon':'glyphicon glyphicon-user'},
					{'name':'meetings','icon':'glyphicon glyphicon-calendar'},
					{'name':'documents','icon':'glyphicon glyphicon-file'}]}/>

				{this.getCommitteeDashboardInstructions()}

				{mainView}
			</section>
		);
	}

}
function mapStateToProps( { committees, searchTerm, selectedPolicyGroup, myCommittees, requestedCommittees, meetings, mainTab, hasSwitchedForDirectLink } ) {
	return {
		committees, searchTerm, selectedPolicyGroup , myCommittees , requestedCommittees, meetings, mainTab, hasSwitchedForDirectLink
	};
}

export default connect( mapStateToProps, { fetchAllCommittees, fetchMyCommittees, joinCommittee, committeeDirectLinkSwitchTab, switchMainTabDispatch  } )( Committees );